import script from "./ExpertSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpertSection.vue?vue&type=script&setup=true&lang=js"

import "./ExpertSection.vue?vue&type=style&index=0&id=e706fd96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e706fd96"]])

export default __exports__